import { useState } from "react";
import { Cookie } from "@phosphor-icons/react";

export function CookieConsent() {
  const [choice, setChoice] = useState(() => localStorage.getItem("artha_cookie_consent"));
  if (choice) return null;
  const decide = (v) => { localStorage.setItem("artha_cookie_consent", v); setChoice(v); };
  return (
    <div data-testid="cookie-consent-banner" className="fixed bottom-0 inset-x-0 z-[100] border-t border-zinc-200 bg-white/95 backdrop-blur px-4 py-3">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row sm:items-center gap-3">
        <p className="text-[12px] text-zinc-600 flex-1 flex items-start gap-2">
          <Cookie size={16} className="text-zinc-400 shrink-0 mt-0.5" />
          <span>We use essential cookies to keep you signed in securely. No advertising or cross-site tracking. See our <a href="https://arthataxes.com/privacy-policy" target="_blank" rel="noreferrer" className="underline text-zinc-800">Privacy Policy</a> for your GDPR/CCPA rights, including data export and deletion from your portal.</span>
        </p>
        <div className="flex gap-2 shrink-0">
          <button data-testid="cookie-accept-btn" onClick={() => decide("accepted")} className="text-xs text-white rounded-md px-4 py-2 transition-colors duration-150" style={{ background: "#3D6B5E" }}>Accept</button>
          <button data-testid="cookie-essential-btn" onClick={() => decide("essential")} className="text-xs text-zinc-600 border border-zinc-300 rounded-md px-4 py-2 hover:bg-zinc-50 transition-colors duration-150">Essential only</button>
        </div>
      </div>
    </div>
  );
}
